import React from 'react';
import './Index.css';
import manicureImage from '../assets/russianmanicurenew.PNG';
import nailArtImage from '../assets/nailartnew.PNG';
import  pedicureImage from '../assets/pedicurenew.PNG';
import discountImage from '../assets/offernew.PNG';
import giftImage from '../assets/holiday.PNG';
import feebackimg from '../assets/girlnew.jpg';
import Nail1 from '../assets/nail1.jpg';
import Nail2 from '../assets/nail2.jpg';
import Nail3 from '../assets/nail3.png';
import Nail4 from '../assets/nail4.jpg';
import Nail5 from '../assets/nail5.jpg';
import Nail6 from '../assets/nail6.jpg';

const Index = () => {
  
    return (
        <>
<div className="container-fluid ps-5 " style={{ backgroundColor: '#fff8f5' }}>
      <div className="row align-items-">
        {/* Left Section */}
        <div className="col-md-6 text-start mt-5 p-5">
          <h1 className="-5 homeheading" style={{ fontFamily: '' }}>
            Luxe Nail Care <br /> & Relaxation <br /> Await You
          </h1>
          <p className="text-muted homecontent">
          Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida.
          </p>
          <div className="mt-3">
            <button className="bt p- homebtn d-flex align-items-center" data-bs-toggle="tooltip" data-bs-placement="top" title="Msilkspa Square site">
              <a href="https://msilkspa-beauty-salon.square.site/" target="_blank" rel="noopener noreferrer">
                Book Appointment Now <span className="ms-1 pt-1"><i className="bi bi-arrow-right-short"></i></span> 
              </a>
            </button>
          </div>       
        </div>

        {/* Right Section - Two Columns */}
        <div className="col-md-6 d-flex justify-content-center gap-2 nailscolumn">
          {/* First Column */}
          <div className="d-flex flex-column gap-2">
            <img src={Nail1} alt="Nail 1" className="nailsimage" style={{ width: "250px", height: "200px", marginTop:'30%' }} />
            <img src={Nail2} alt="Nail 2" className="nailsimage" style={{ width: "250px", height: "200px" }} />
            <img src={Nail3} alt="Nail 3" className="nailsimage" style={{ width: "250px", height: "150px" }} />
          </div>

          {/* Second Column */}
          <div className="d-flex flex-column gap-2 " >
            <img src={Nail4} alt="Nail 4" className="nailsimage" style={{ width: "250px", height: "150px" ,marginBottom:'-0%' }} />
            <img src={Nail5} alt="Nail 5" className="nailsimage" style={{ width: "250px", height: "200px" }} />
            <img src={Nail6} alt="Nail 6" className="nailsimage" style={{ width: "250px", height: "200px" }}  />
          </div>
        </div>
      </div>
    </div>


    <div className="container pt-3">
  <div className=" justify-content-center">
    <div className="col-auto">
      <p className="homeservice text-center pt-5">Services</p>
      <p className="splfeature text-center">Special Feature</p>
      <p className="splfeaturecontent text-center pt-3">Lorem ipsum dolor curabitur sed tellus ipsum. Sed tristique ut orci ut gravida. Curabitur sed tellus ipsum. Sed tristique ut orci ut gravida.</p>
      </div>
   
  </div>
</div>

    <div className="d-flex flex-wrap justify-content-center pt-4 " style={{paddingRight:'9rem',paddingLeft:'9rem'}}>
  <div className="col-12 col-md-4 p-2 ">
    <div className="card img-fluid" style={{ width: "100%", padding: "0px" }}>
      <img
        className="card-img-top p-2  ms-2 mt-2"
        src={manicureImage}
        alt="Manicure service"
        style={{ width: "25%", height: "50px" }}
      />
      <div className="card-body">
        <p className="card-text text-start servicename">Russian Manicure</p>
        <p className='splfeatureimage text-start pt-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur.</p>
      <p className='text-start pt-2' style={{textDecoration:'underline'}}><a href='#' style={{fontSize:'14px'}}>View More</a></p>
      </div>
    </div>
  </div>

  <div className="col-12 col-md-4 p-2 ">
    <div className="card img-fluid" style={{ width: "100%", padding: "0px" }}>
      <img
        className="card-img-top p-2 ms-2 mt-2"
        src={pedicureImage}
        alt="Pedicure Service"
        style={{ width: "25%", height: "50px" }}
      />
      <div className="card-body mt-0">
        <p className="card-text text-start servicename">Luxury Pedicure</p>
        <p className='splfeatureimage text-start pt-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur.</p>
        <p className='text-start pt-2' style={{textDecoration:'underline'}}><a href='#' style={{fontSize:'14px'}}>View More</a></p>
        </div>
    </div>
  </div>

  <div className="col-12 col-md-4 p-2 ">
    <div className="card img-fluid" style={{ width: "100%", padding: "0px" }}>
      <img
        className="card-img-top p-2 ms-2 mt-2"
        src={nailArtImage}
        alt="Nailart Service"
        style={{ width: "25%", height: "50px" }}
      />
      <div className="card-body">
        <p className="card-text text-start servicename">Nail Art</p>
        <p className='splfeatureimage text-start pt-2'>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Lorem ipsum dolor sit amet, consectetur.</p>
        <p className='text-start pt-2' style={{textDecoration:'underline'}}><a href='#' style={{fontSize:'14px'}}>View More</a></p>
        </div>
    </div>
  </div>
</div>

   
    <div className="pt-4 d-flex justify-content-center   ">
       <button className='bt viewallservice '>
       <a href="/Service">View All Services <span className="ms-"><i className="bi bi-arrow-right-short"></i></span></a>
       </button>
    </div>

    <div className="container my-5 pt-2">
      <div className="row justify-content-center">
          <div className="col-md-4 mb-2">
              <div className=" ">
                <img src={discountImage}  alt=''  width="100%" height="300px" />
              </div>
          </div>
          <div className="col-md-4 mb-2">
              <div className="">
                 <img src={giftImage} alt="" width="100%" height="300px" />
              </div>
          </div>
      </div>
  </div>

<div id="testimonialCarousel" className="carousel slide pb-5 pt-5" data-bs-ride="carousel">
      <div className="carousel-inner">
        {/* First Slide */}
        <div className="carousel-item active">
          <div className="testimonial-card text-center">
            <p className="fw-bold text-uppercase testmonial">Testimonials</p>
            <h3 className="fw-b ourcusfeedback" >Our Customer Feedback</h3>
            <p className="text-muted cuscontent">
              Our services are designed to inspire you to feel better, look better, and embrace a healthier lifestyle.
            </p>
            <div className="star-rating my-3">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text ">“MSilk Spa transformed my nails like no other! Their attention to detail is unmatched.”</p>
            <div className="d-flex justify-content-center align-items-center pt-4">
              <img src={feebackimg} alt="Customer" className="customer-image me-2" />
              <span className="fw-bold border-end border-2 border-dark pe-3">Sarah</span>  
              <span className="fw-bold fst-italic ms-3 text-">webflow</span>

            </div>
          </div>
        </div>

        {/* Second Slide */}
        <div className="carousel-item">
          <div className="testimonial-card text-center">
            <p className="fw-bold text-uppercase">Testimonials</p>
            <h3 className="fw- ourcusfeedback">Our Customer Feedback</h3>
            <p className="text-muted cuscontent">We value our customers and their feedback. Here’s what they have to say.</p>
            <div className="star-rating my-3">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text">“Amazing experience! The service was exceptional, and I highly recommend it.”</p>
            <div className="d-flex justify-content-center align-items-center pt-4">
              <img src={feebackimg} alt="Customer" className="customer-image me-2" />
              <span className="fw-bold border-end border-2 border-dark pe-3">John</span>
              <span className="fw-bold fst-italic ms-3">webflow</span>
            </div>
          </div>
        </div>

        {/* Third Slide */}
        <div className="carousel-item">
          <div className="testimonial-card text-center">
            <p className="fw-bold text-uppercase textimonials">Testimonials</p>
            <h3 className="fw- ourcusfeedback">Our Customer Feedback</h3>
            <p className="text-muted cuscontent">We value our customers and their feedback. Here’s what they have to say.</p>
            <div className="star-rating my-3">⭐⭐⭐⭐⭐</div>
            <p className="testimonial-text">“Amazing experience! The service was exceptional, and I highly recommend it.”</p>
            <div className="d-flex justify-content-center align-items-center pt-4">
              <img src={feebackimg} alt="Customer" className="customer-image me-2" />
              <span className="fw-bold border-end border-2 border-dark pe-3">Jenny</span> 
              <span className="fw-bold fst-italic ms-3">webflow</span>
            </div>
          </div>
        </div>
      </div>

      {/* Carousel Controls */}
      <button className="carousel-control-prev" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="prev">
        <span className="carousel-control-prev-icon" aria-hidden="false"></span>
      </button>
      <button className="carousel-control-next" type="button" data-bs-target="#testimonialCarousel" data-bs-slide="next">
        <span className="carousel-control-next-icon" aria-hidden="false"></span>
      </button>

      {/* Indicators */}
      <div className="carousel-indicators">
        <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="0" className="active"></button>
        <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="1"></button>
        <button type="button" data-bs-target="#testimonialCarousel" data-bs-slide-to="2"></button>
      </div>
    </div>


  </>
    );
}

export default Index;

 